module.exports = __webpack_public_path__ + "static/media/slider-planta.586bea69.png";